import { createFileRoute } from '@tanstack/react-router'
import MatchToolPage from '@/pages/MatchToolPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/match-tool')({
  component: MatchToolPage,
})